import { Controller } from "@hotwired/stimulus"

// Generic toggle controller for showing/hiding elements.
//
// Usage:
//   <div data-controller="toggle">
//     <button data-action="click->toggle#toggle">Toggle</button>
//     <div data-toggle-target="content" class="hidden">Content</div>
//   </div>
//
// For "hide only" buttons inside the toggled content:
//   <button data-action="click->toggle#hide">Cancel</button>
//
export default class extends Controller {
  static targets = ["content"]

  toggle() {
    this.contentTargets.forEach(el => el.classList.toggle("hidden"))
  }

  show() {
    this.contentTargets.forEach(el => el.classList.remove("hidden"))
  }

  hide() {
    this.contentTargets.forEach(el => el.classList.add("hidden"))
  }
}
